import { render } from "./LaPhotothequePage.vue?vue&type=template&id=0946d4ca"
import script from "./LaPhotothequePage.vue?vue&type=script&lang=js"
export * from "./LaPhotothequePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__